<h3>{{title}}</h3>
<form [formGroup]="resourceForm" (ngSubmit)="onSubmit()"  *ngIf="!confirm">

  <mat-form-field appearance="outline">
    <mat-label>Nom</mat-label>
    <input matInput type="text" formControlName="lastName">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Prénom</mat-label>
    <input matInput type="text" formControlName="firstName">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Pseudo</mat-label>
    <input matInput type="text" formControlName="pseudo">
  </mat-form-field>
  
 <mat-form-field appearance="outline">
  <mat-label>N° Club</mat-label>
  <mat-select formControlName="clubCode">
    <mat-option *ngFor="let c of clubs" [value]="c"> <strong>{{c.code}}</strong> - {{c.name}}</mat-option>
  </mat-select>
</mat-form-field>
 
  <div class="btn_action">
    <button class="back" type="button" (click)="closeDialog()">Annuler</button>
    <button [ngClass]="{not_confirm: resourceForm.invalid, confirm: resourceForm.valid}" type="submit"
      [disabled]="resourceForm.invalid" appChangeColorTheme attribute="bgc" >{{btnConfirm}}</button>
  </div>

</form>

<app-validation-animation [text]="text" *ngIf="confirm" ></app-validation-animation>

